<div class="login-page">
  <h1>Welcome to the Project Portfolio Application</h1>
  <p>Please <button class="secondary" (click)="login()" title="Login into PPR">Login</button> into PPR in order to view any projects.</p>
</div>
